import { render, staticRenderFns } from "./PriceItemOption.vue?vue&type=template&id=38077a2f&scoped=true"
import script from "./PriceItemOption.vue?vue&type=script&lang=ts"
export * from "./PriceItemOption.vue?vue&type=script&lang=ts"
import style0 from "./PriceItemOption.vue?vue&type=style&index=0&id=38077a2f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38077a2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38077a2f')) {
      api.createRecord('38077a2f', component.options)
    } else {
      api.reload('38077a2f', component.options)
    }
    module.hot.accept("./PriceItemOption.vue?vue&type=template&id=38077a2f&scoped=true", function () {
      api.rerender('38077a2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/PriceItemOption.vue"
export default component.exports